import React, {Component} from "react";
import {addInstitution, deleteInstitution, getInstitutions, updateInstitution} from "../../services/InstitutionService";
import CustomLoader from "../common/Loader";
import * as Icon from "react-feather";
import {Modal} from "react-bootstrap";
import Tooltip from "@material-ui/core/Tooltip";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../config';

class Institutions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            institutionList: [],
            loading: false,
            show: false,
            new_institution: {
                Institution_Name: "",
                Institution_Description: "",
                Institution_Code: ''
            },
            editMode: false,
            edit_idx: 0,
            institution_copy: {},
        }
    }

    async componentDidMount() {
        this.setState({loading: true})
        await getInstitutions().then(resp => {
            this.setState({institutionList: resp.data, loading: false})
        })
    }

    handleSave = async (idx) => {
        const { data } = await updateInstitution(this.state.institutionList[idx]);
        if (typeof data === "string" && data.includes("Error")) {
            toaster('error', data);
        } else {
            let institutionList = [...this.state.institutionList];
            institutionList[idx] = data;
            this.setState({ institutionList });
            toaster('success', 'Institution Saved.');
            this.disableEdit();
        }
    };

    handleSaveNew = async () => {
        const { data } = await addInstitution(this.state.new_institution);
        if (typeof data === "string" && data.includes("Error")) {
            toaster('error', data);
        } else {
            const newInstitution = {
                Institution_ID: data.split(':')[1],
                Institution_Name: this.state.new_institution['Institution_Name'],
                Institution_Description: this.state.new_institution['Institution_Description'],
                Institution_Code: this.state.new_institution['Institution_Code']
            }
            const institutionList = [...this.state.institutionList, newInstitution];
            this.setState({ institutionList });
            const new_institution = {
                Institution_Name: "",
                Institution_Description: "",
                Institution_Code:''
            };
            this.setState({ new_institution });
            toaster('success', 'Institution saved.');
            this.handleClose();
        }
    };

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    enableEdit = (idx) => {
        // const user_copy = this.state.Users.map((user) => ({ ...user }));
        const institution_copy = { ...this.state.institutionList[idx] };
        this.setState({ institution_copy });
        this.setState({ edit_idx: idx });
        this.setState({ edit_mode: true });
    };

    disableEdit = () => {
        this.setState({ edit_idx: -1 });
        this.setState({ edit_mode: false });
    };

    restoreInstitution = () => {
        // const Users = this.state.Users_copy.map((user) => ({ ...user }));
        let institutionList = [...this.state.institutionList];
        institutionList[this.state.edit_idx] = { ...this.state.institution_copy };
        this.setState({ institutionList });
        this.setState({ institution_copy: {} });
        this.disableEdit();
    };

    handleUserEdit = (name, value, index, isSelect = false) => {
        const institutionList = [...this.state.institutionList];
        if (isSelect) {
            value = parseInt(value);
        }
        institutionList[index][name] = value;
        this.setState({ institutionList });
    };

    handleNewInstitutionChange = (name, value, isSelect = false) => {
        const new_institution = { ...this.state.new_institution };
        if (isSelect) {
            value = parseInt(value);
        }
        new_institution[name] = value;
        this.setState({ new_institution });
    };

    handleRemove = async (UID) => {
        const { data } = await deleteInstitution(this.state.institutionList.filter(institution => institution.Institution_ID === UID)[0]);
        if (data['Institution_ID'] == null) {
            toaster('error', data);
        } else {
            toaster('success', data);
            const institutionList = this.state.institutionList.filter((institution) => institution.Institution_ID !== UID);
            this.setState({ institutionList });
        }
    };

    render() {
        if (this.state.loading) {
            return <CustomLoader loading={this.state.loading} />;
        }

        let {institutionList, show, new_institution} = this.state;

        return (
            <React.Fragment>
                <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
                    <div className="container">
                        <div className="page-header-content pt-4">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto mt-4">
                                    <h1 className="page-header-title">
                                        <div className="page-header-icon">
                                            <Icon.Users />
                                        </div>
                                        Institutions
                                    </h1>
                                    <div className="page-header-subtitle">
                                        MQUARK Institution management application wide.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="container mt-n10">
                    <div className="card card-header-actions">
                        <div className="card-body">
                            <div className="float-right">
                                <button
                                    className="btn btn-pink btn-icon mr-2"
                                    onClick={this.handleShow}
                                >
                                    <Icon.PlusCircle />
                                </button>
                                <Modal show={show} onHide={this.handleClose}>
                                    <Modal.Header closeButton>New Institution</Modal.Header>
                                    <Modal.Body>
                                        <form>
                                            <div className="form-group">
                                                <label htmlFor="FirstName">Institution Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="FirstName"
                                                    name="First_Name"
                                                    value={new_institution.Institution_Name}
                                                    onChange={(e) =>
                                                        this.handleNewInstitutionChange(
                                                            "Institution_Name",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="LastName">Institution Description</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="LastName"
                                                    name="Last_Name"
                                                    value={new_institution.Institution_Description}
                                                    onChange={(e) =>
                                                        this.handleNewInstitutionChange(
                                                            "Institution_Description",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div>
                                            <label htmlFor="Institution_Code">Institution Code</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="Institution_Code"
                                                    name="Institution_Code"
                                                    value={new_institution.Institution_Code}
                                                    onChange={(e) =>
                                                        this.handleNewInstitutionChange(
                                                            "Institution_Code",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.handleSaveNew}
                                        >
                                            Save
                                        </button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                            <table className="table table-hover table-borderless table-sm" style={{tableLayout:'fixed'}}>
                                <thead className="border-bottom">
                                    <tr>
                                        <th>Institution ID</th>
                                        <th>Institution Name</th>
                                        <th>Institution Description</th>
                                        <th>Institution Code</th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody>
                                {institutionList.map((institution, idx) => {
                                    if (this.state.edit_mode && idx === this.state.edit_idx) {
                                        return (
                                            <tr key={institution.Institution_ID}>
                                                <td>{institution.Institution_ID}</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={institution.Institution_Name}
                                                        onChange={(e) =>
                                                            this.handleUserEdit(
                                                                "Institution_Name",
                                                                e.target.value,
                                                                idx
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={institution.Institution_Description}
                                                        onChange={(e) =>
                                                            this.handleUserEdit(
                                                                "Institution_Description",
                                                                e.target.value,
                                                                idx
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td>{institution.Institution_Code}</td>
                                                <td>
                                                    <Tooltip title="Save" id={`save-${institution.Institution_ID}`}>
                                                        <span
                                                          className="badge badge-cyan"
                                                          onClick={() => this.handleSave(idx)}
                                                        >
                                                            <Icon.Save size={20} />
                                                        </span>
                                                    </Tooltip>
                                                    &nbsp;&nbsp;
                                                    <Tooltip
                                                        title="Cancel"
                                                        id={`cancel-${institution.Institution_ID}`}
                                                    >
                                                        <span
                                                          className="badge badge-orange"
                                                          onClick={() => this.restoreInstitution()}
                                                        >
                                                            <Icon.X size={15} />
                                                        </span>
                                                    </Tooltip>
                                                </td>
                                            </tr>
                                        );
                                    } else {
                                        return (
                                            <tr key={institution.Institution_ID}>
                                                <td>{institution.Institution_ID}</td>
                                                <td>{institution.Institution_Name}</td>
                                                <td>{institution.Institution_Description}</td>
                                                <td>{institution.Institution_Code}</td>
                                                <td>
                                                    <Tooltip title="Edit" id={`edit-${institution.Institution_ID}`}>
                                                        <span
                                                          className="badge badge-cyan"
                                                          onClick={() => this.enableEdit(idx)}
                                                        >
                                                        <Icon.Edit size={20} />
                                                        </span>
                                                    </Tooltip>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <Tooltip
                                                        title="Delete"
                                                        id={`delete-${institution.Institution_ID}`}
                                                    >
                                                        <span
                                                          className="badge badge-danger"
                                                          onClick={() => this.handleRemove(institution.Institution_ID)}
                                                        >
                                                        <Icon.Trash2 size={15} />
                                                        </span>
                                                    </Tooltip>
                                                </td>
                                            </tr>
                                        );
                                    }
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <ToastContainer/>
            </React.Fragment>
        );
    }
}

export default Institutions;